import id from './{id}';
import get from './get';
import commands from './commands';
import parserfunctions from './parserfunctions';
import post from './post';
import settings from './settings';

export default { get, id, commands, settings, parserfunctions, post };
